const NAMES = {
  bed_king: "King bed", bed_queen: "Queen bed", bed_twin: "Twin bed", kitchen_sink: "Kitchen sink", water_heater: "Water heater",
  coffee_table: "Coffee table", tv_console: "TV console", dining_table: "Dining table", gfci: "GFCI outlet",
};
const nice = (t) => NAMES[t] || t.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());

const count = (list, pred) => list.filter(pred).reduce((m, x) => ({ ...m, [x.type]: (m[x.type] || 0) + 1 }), {});

const Group = ({ title, data, testid }) => (
  <div data-testid={testid}>
    <p className="font-mono text-[10px] uppercase tracking-widest text-[var(--muted)] mb-1.5">{title}</p>
    <div className="grid grid-cols-2 gap-x-4 gap-y-1">
      {Object.entries(data).sort().map(([k, v]) => (
        <div key={k} className="flex justify-between text-xs"><span className="text-[var(--ink)]/85 truncate">{nice(k)}</span><span className="font-mono text-[var(--cyan)]">{v}</span></div>
      ))}
    </div>
  </div>
);

export const FitoutSummary = ({ plan }) => {
  const items = plan.floors.flatMap((f) => f.fitout?.items || []).filter((i) => i.type !== "counter");
  const el = plan.floors.flatMap((f) => f.fitout?.electrical || []).filter((e) => e.type !== "circuit");
  const fixtures = count(items, (i) => i.cat !== "furniture");
  const furniture = count(items, (i) => i.cat === "furniture");
  return (
    <div className="space-y-4" data-testid="fitout-summary">
      <Group title="Fixtures & appliances" data={fixtures} testid="fitout-fixtures" />
      <Group title="Furniture" data={furniture} testid="fitout-furniture" />
      <Group title="Electrical devices" data={count(el, () => true)} testid="fitout-electrical" />
      <p className="text-[11px] text-[var(--muted)] leading-relaxed">Auto-laid out from each room’s type and doors, and re-fitted after every AI revision or wall drag. Included in the 3D view, Rhino files and PDF sheets (A, E and P).</p>
    </div>
  );
};
